import { useState, KeyboardEvent } from "react";
import { Flex, Image } from "@chakra-ui/react";
import { RectShape } from "react-placeholder/lib/placeholders";

interface ISimpleSwitchProps {
  // Controlled value (if provided, o componente passa a ser controlado externamente)
  isActive?: boolean;
  // Valor inicial quando usado de forma não controlada
  defaultIsActive?: boolean;
  // Callback chamado sempre que o valor mudar
  onChange?: (value: boolean) => void;

  disabled?: boolean;
  isLoading?: boolean;

  // Estilo
  width?: string;

  // Acessibilidade
  id?: string;
  ariaLabel?: string;
}

export const Switch = ({
  isActive,
  defaultIsActive = false,
  onChange,
  disabled = false,
  isLoading = false,
  width = "50px",
  id,
  ariaLabel,
}: ISimpleSwitchProps) => {
  const [internalActive, setInternalActive] = useState<boolean>(defaultIsActive);

  const isControlled = typeof isActive === "boolean";
  const currentValue = isControlled ? (isActive as boolean) : internalActive;

  const image = currentValue ? "../icons/switch-blue.svg" : "../icons/switch-gray.svg";

  const handleToggle = () => {
    if (disabled || isLoading) return;

    const nextValue = !currentValue;

    if (!isControlled) {
      setInternalActive(nextValue);
    }

    onChange?.(nextValue);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <Flex
      id={id}
      role="switch"
      aria-checked={currentValue}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      tabIndex={disabled ? -1 : 0}
      display="inline-flex"
      alignItems="center"
      cursor={disabled || isLoading ? "not-allowed" : "pointer"}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
    >
      {isLoading ? (
        <RectShape
          color="#e0e0e0"
          style={{
            width,
            height: "23px",
            borderRadius: "50px",
          }}
        />
      ) : (
        <Image src={image} width={width} opacity={disabled ? 0.3 : 1} draggable={false} />
      )}
    </Flex>
  );
};
